import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-management',
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './user-management.html'
})
export class UserManagementComponent {}
